import React, { useState, useEffect } from 'react';
import BackButton from '../../components/button/BackButton';
import { SmsConnexion } from './phoneNumberLogin/SmsConnexion';
import 'react-phone-number-input/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import 'react-international-phone/style.css';
import { auth } from '../../firebase/firebaseConfig';
import { phoneNumberSignUp, verifyOTP } from './phoneNumberLogin/services/phoneAuthService';
import LoaderWithText from '../../components/loader/LoaderWithText';
import { notifyError, notifySuccess, notifyWarning } from '../../utils/Notify';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxios
 from '../../axios/useAxios';
import GetUserPhoneInfo from './phoneNumberLogin/GetUserPhoneInfo';
import {
  savePhoneNumberUser,
  saveUserWithFid,
} from '../../actions/userActions';
import {
  changePassword,
  checkIfUserPhoneExists,
} from '../../actions/userPhoneAction';
import { PhonePasswordSignIn } from './phoneNumberLogin/phonePasswordSignIn';
import { PhonePasswordSignUp } from './phoneNumberLogin/phonePasswordSignUp';
import {
  ACCOUNT,
  HOME,
  INVITATION,
  LOGIN,
  NUMBER_SCREEN,
  SCAN,
} from '../../constants/routes';
import { CountrySelector } from 'react-international-phone';
import { isAppPWA } from '../../utils/helper-functions';
import { useTheme } from 'styled-components';
import { useFunnelTracking } from '../../posthog/funnelTracking';
import {
  VALIDATION_CONSTANTS,
  TIMING_CONSTANTS,
  ERROR_TYPES,
  FIREBASE_STORAGE_KEYS,
  USER_MESSAGES,
  AUTH_STEPS
} from './constants/numberScreenConstants';
import { getRemainingWaitTime } from './phoneNumberLogin/services/rateLimitService';

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    console.error('Error validating phone number:', error);
    return false;
  }
};



const shouldSkipRateLimit = (lastAttemptDate, currentTime) => {
  return lastAttemptDate && (currentTime - lastAttemptDate < VALIDATION_CONSTANTS.RATE_LIMIT_DELAY_MS);
};

const GetPhoneRedirectInfo = async (
  auth,
  setLoadingConnexion,
  dispatch,
  axiosInstance,
  cartItems,
  navigate,
  result,
  password,
  action,
  number,
  setLockUntil,
  setError,
) => {
  try {
    const authData = action === 'signup'
      ? auth
      : { currentUser: { phoneNumber: number } };

    const data = await GetUserPhoneInfo(authData, result, password);

    if (data.newResult.profile.fidCardNum) {
      const fidCardNum = data.newResult.profile.fidCardNum;
      dispatch(
        saveUserWithFid(
          data.newResult.profile,
          axiosInstance,
          cartItems,
          fidCardNum,
          navigate,
        ),
      );
    } else {
      await dispatch(
        savePhoneNumberUser(
          data.newResult.profile,
          axiosInstance,
          cartItems,
          navigate,
          action,
          setLockUntil,
          setError,
        ),
      );
    }

    setLoadingConnexion(false);
  } catch (error) {
    setLoadingConnexion(false);
    console.error('Erreur lors de l\'authentification:', error);
  }
};

const NumberScreen = ({ allowOtherLoginMethod }) => {
  const theme = useTheme();
  const [step, setStep] = React.useState(1);
  const [number, setNumber] = React.useState('');
  const [finalNumber, setFinalNumber] = React.useState('');
  const [passwordError, setPasswordError] = React.useState('');
  const [code, setCode] = React.useState('');
  const isValid = isPhoneValid(finalNumber);
  const [, setLoading] = React.useState(false);
  const [loadingSubmitNumber, setLoadingSubmitNumber] = React.useState(false);
  const [loadingOtp, setLoadingOtp] = React.useState(false);
  const [result, setResult] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [dialCode, setDialCode] = React.useState('33');
  const [checkPassword, setCheckPassword] = React.useState('');
  const [forgotPassword, setForgotPassword] = React.useState(false);
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [country, setCountry] = useState('fr');
  const axiosInstance = useAxios();
  const { cartItems } = useSelector((state) => state.cart);
  const [isExist, setIsExist] = React.useState(false);
  const [lockUntil, setLockUntil] = React.useState(null);
  const { userNotConnected } = useLocation().state || false;
  const { prevPage, entryQr } = useLocation().state || '';
  const { trackPageViewPhoneNumber } = useFunnelTracking();
  const [waitTime, setWaitTime] = React.useState(0);

  const checkWaitTime = () => {
    const remainingTime = getRemainingWaitTime();
    setWaitTime(remainingTime);
  };

  useEffect(() => {
    trackPageViewPhoneNumber({});
    checkWaitTime();

    const interval = setInterval(checkWaitTime, TIMING_CONSTANTS.WAIT_TIME_CHECK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [trackPageViewPhoneNumber]);

  const isPWA = isAppPWA();

  const onNumberChange = (e) => {
    const { value } = e.target;
    if (/^\d*$/.test(value) && value.length <= 20) {
      setNumber(value);
    } else {
      return;
    }
  };

  useEffect(() => {
    if (user && user._id) {
      if (prevPage === SCAN) {
        navigate(SCAN);
      } else {
        navigate(ACCOUNT, { state: { entryQr: entryQr || '' } });
      }
    }
    if (window.location.pathname === '/config') {
      localStorage.setItem('PREV_LOGIN_PAGE', 'config');
    }
    if (userNotConnected) {
      localStorage.setItem('isNewPWA', 'true');
    }
    setCode('');
    setPassword('');
    setCheckPassword('');
  }, []);
  const handleNumberSubmission = async (type, id) => {
    if (finalNumber.length < VALIDATION_CONSTANTS.MIN_PHONE_LENGTH) {
      notifyWarning(USER_MESSAGES.INVALID_NUMBER);
      return;
    }

    setLoadingSubmitNumber(true);

    try {
      const userCheck = await checkIfUserPhoneExists(axiosInstance, finalNumber);

      if (userCheck.success) {
        setIsExist(true);
        setStep(AUTH_STEPS.PASSWORD_SETUP);
        setLoadingSubmitNumber(false);
        return;
      }

      if (userCheck.serverError) {
        notifyError('Erreur lors de la vérification du numéro');
        setLoadingSubmitNumber(false);
        return;
      }

      setIsExist(false);
      const lastAttemptDate = localStorage.getItem(FIREBASE_STORAGE_KEYS.LAST_ATTEMPT_DATE);
      const currentTime = new Date().getTime();

      if (shouldSkipRateLimit(lastAttemptDate, currentTime)) {
        setStep(AUTH_STEPS.OTP_VERIFICATION);
        setLoadingSubmitNumber(false);
        return;
      }

      if (!isValid) {
        notifyWarning('Numéro invalide');
        setLoadingSubmitNumber(false);
        return;
      }

      const result = await phoneNumberSignUp(
        auth,
        finalNumber,
        setStep,
        type,
        id,
        setLoadingSubmitNumber
      );

      if (result?.success) {
        localStorage.setItem(FIREBASE_STORAGE_KEYS.LAST_ATTEMPT_DATE, currentTime.toString());
        setStep(AUTH_STEPS.OTP_VERIFICATION);
      } else {
        handleSignUpError(result?.error);
      }

    } catch (error) {
      console.error('Erreur inattendue:', error);
      notifyError('Erreur inattendue lors de l\'envoi du code');
      setLoadingSubmitNumber(false);
      return;
    }


  };

  const handleSignUpError = (errorType) => {
    switch (errorType) {
      case ERROR_TYPES.RATE_LIMITED:
        checkWaitTime();
        break;
      case ERROR_TYPES.USER_CANCELLED:
        console.log('Utilisateur a annulé le reCAPTCHA');
        break;
      case 'reCAPTCHA timeout':
        console.log('Timeout reCAPTCHA');
        break;
      case ERROR_TYPES.TOO_MANY_REQUESTS:
        notifyError('Trop de requêtes.. Réessaye plus tard');
        break;
      default:
        notifyError('Erreur lors de l\'envoi du code');
        break;
    }
  };

  const buttonref = React.useRef();

  const passwordValidation = async (action) => {
    setLoading(true);

    if (!isExist) {
      if (password !== checkPassword) {
        notifyError('Les mots de passe ne correspondent pas');
        setLoading(false);
        return;
      }
      if (password.length < 6) {
        notifyError('Le mot de passe doit contenir au moins 6 caractères');
        setLoading(false);
        return;
      }
    }

    if (action === 'forgot') {
      const result = await changePassword(
        axiosInstance,
        finalNumber,
        password,
        setLockUntil,
      );
      if (result.success) {
        notifySuccess('Mot de passe modifié');
        setForgotPassword(false);
        setStep(AUTH_STEPS.PASSWORD_SETUP);
      } else {
        notifyError('Erreur lors de la modification du mot de passe');
      }
      setLoading(false);
      return;
    }

    const results = await GetPhoneRedirectInfo(
      auth,
      setLoading,
      dispatch,
      axiosInstance,
      cartItems,
      navigate,
      result.user,
      password,
      action,
      finalNumber,
      setLockUntil,
      setPasswordError,
    );

    if (results) {
      notifySuccess('Connexion réussie');
    }
    setPassword('');

    checkIfLock();
  };
  const checkIfLock = () => {
    const lockUntil = localStorage.getItem('lockUntil');
    if (lockUntil) {
      const lockUntilDate = new Date(lockUntil);
      if (lockUntilDate > new Date()) {
        setLockUntil(lockUntilDate);
      } else {
        localStorage.removeItem('lockUntil');
        setLockUntil(null);
      }
    } else {
      setLockUntil(null);
    }
  };

  useEffect(() => {
    checkIfLock();
  }, []);

  const handleOtpVerification = async (otpCode) => {
    if (otpCode.length !== VALIDATION_CONSTANTS.OTP_LENGTH) return;

    setLoading(true);
    setLoadingOtp(true);

    try {
      const result = await verifyOTP(auth, otpCode);
      if (result.user && result.success) {
        setResult(result);

                  if (forgotPassword) {
            setStep(AUTH_STEPS.FORGOT_PASSWORD);
          } else {
            setStep(AUTH_STEPS.PASSWORD_SETUP);
          }
              } else {
          notifyError(USER_MESSAGES.INCORRECT_CODE);
        }
          } catch (error) {
        notifyError(USER_MESSAGES.VERIFICATION_ERROR);
      } finally {
      setCode('');
      setLoading(false);
      setLoadingOtp(false);
    }
  };

  const handleCodeChange = (newCode) => {
    setCode(newCode);

    if (newCode.length === VALIDATION_CONSTANTS.OTP_LENGTH) {
      handleOtpVerification(newCode);
    }
  };

  const numberRef = React.useRef();
  useEffect(() => {
    let newNumber = number;
    if (newNumber[0] === '0') {
      newNumber = newNumber.slice(1);
    }
    setFinalNumber('+' + dialCode + newNumber);
  }, [number, dialCode]);

  const handleNewPassword = (value) => {
    setPassword(value);
  };

  const handleNewCheckPassword = (value) => {
    setCheckPassword(value);
  };

  const handleSignInPassword = (value) => {
    setPassword(value);
  };
  const swicthConnectionMethod = () => {
    if (prevPage === INVITATION) {
      navigate(LOGIN, {
        state: { prevPage: NUMBER_SCREEN, numberSreenPrevPage: INVITATION },
      });
    } else {
      navigate(LOGIN, { state: { prevPage: NUMBER_SCREEN } });
    }
  };
  return (
    <>
      <div className="smsLogin relative">
        {(user.loading || loadingOtp) && (
          <LoaderWithText text="Chargement en cours" />
        )}

        <div className="inputBackButton">
                      {(!isPWA || (isPWA && step !== AUTH_STEPS.PHONE_INPUT)) && (
            <div className={`${step === AUTH_STEPS.PASSWORD_SETUP && !isExist ? 'hidden' : ''}`}>
              <BackButton
                iconOnly
                isLogoVisible={true}
                onClick={() => {
                  switch (step) {
                    case 1:
                      if (prevPage) {
                        navigate(prevPage, {
                          state: { prevPage: NUMBER_SCREEN },
                        });
                      } else {
                        navigate(HOME);
                      }

                      break;
                    case AUTH_STEPS.OTP_VERIFICATION:
                      setStep(AUTH_STEPS.PHONE_INPUT);
                      break;
                    case AUTH_STEPS.PASSWORD_SETUP:
                      if (isExist) {
                        setStep(AUTH_STEPS.PHONE_INPUT);
                      } else {
                        setStep(AUTH_STEPS.OTP_VERIFICATION);
                      }
                      break;
                    case AUTH_STEPS.FORGOT_PASSWORD:
                      setStep(AUTH_STEPS.PASSWORD_SETUP);
                      break;
                    default:
                      break;
                  }
                }}
              />
            </div>
          )}

          {step === AUTH_STEPS.PHONE_INPUT ? (
            <div className="headerSmsConnexion">
              <div className="circle-gradient">
                {theme?.logos?.loginLogo && (
                  <img
                    src={theme.logos.loginLogo.image}
                    alt="loginLogo"
                    className="dracu-pikko"
                  />
                )}
              </div>
              <div className="instructions">
                <h1>Pikko Compte</h1> Tape ton numéro de téléphone !
              </div>
              <div className="inputSms">
                <div className="PhoneCountryCode">
                  <CountrySelector
                    selectedCountry={country}
                    onSelect={({ iso2, dialCode }) => {
                      setCountry(iso2);
                      setDialCode(dialCode);
                    }}
                  />
                </div>
                <div className="phoneInputGroup">
                  <div>+{dialCode}</div>
                  <input
                    autoComplete="tel"
                    value={number}
                    onChange={onNumberChange}
                    ref={numberRef}
                    type="tel"
                    name="tel"
                    className="inputNumber"
                    id="inputNumber"
                  />
                </div>
              </div>

              {waitTime > 0 && (
                <div style={{
                  color: '#ff6b6b',
                  fontSize: '14px',
                  marginBottom: '10px',
                  textAlign: 'center',
                  padding: '8px',
                  backgroundColor: '#ffe0e0',
                  borderRadius: '4px',
                  border: '1px solid #ffb3b3'
                }}>
                  ⏰ Trop de tentatives détectées. Veuillez patienter {waitTime} minute(s) avant de réessayer.
                </div>
              )}

              <div id="recaptcha-container" style={{ display: 'none' }} />

              <div
                onClick={(e) =>
                  !waitTime && !loadingSubmitNumber ? handleNumberSubmission('invisible', 'recaptcha-container') : null
                }
                ref={buttonref}
                disabled={loadingSubmitNumber || waitTime > 0}
                className={`primary-button ${waitTime > 0 ? 'disabled' : ''}`}
                style={{
                  opacity: waitTime > 0 ? 0.5 : 1,
                  cursor: waitTime > 0 ? 'not-allowed' : 'pointer'
                }}
              >
                {waitTime > 0
                  ? `Attendez ${waitTime} minute(s)`
                  : loadingSubmitNumber
                    ? 'Chargement...'
                    : 'Continuer'
                }
              </div>
              {allowOtherLoginMethod && (
                <button
                  className="otherMethod"
                  onClick={swicthConnectionMethod}
                >
                  Autre méthode de connexion
                </button>
              )}
            </div>
          ) : step === AUTH_STEPS.OTP_VERIFICATION ? (
            <SmsConnexion
              code={code}
              setCode={handleCodeChange}
              number={finalNumber}
              auth={auth}
              setStep={setStep}
              setForgotPassword={setForgotPassword}
              setLoading={setLoading}
            />
          ) : step === AUTH_STEPS.PASSWORD_SETUP ? (
            isExist ? (
              <PhonePasswordSignIn
                handleSignInPassword={handleSignInPassword}
                valider={() => passwordValidation('signin')}
                setStep={setStep}
                number={finalNumber}
                setForgotPassword={setForgotPassword}
                auth={auth}
                passwordError={passwordError}
                lockUntil={lockUntil}
                setLockUntil={setLockUntil}
                setLoading={setLoading}
                setPasswordError={setPasswordError}
              />
            ) : (
              <PhonePasswordSignUp
                password={password}
                setPassword={setPassword}
                checkPassword={checkPassword}
                setCheckPassword={setCheckPassword}
                setStep={setStep}
                valider={() => passwordValidation('signup')}
                backFunction={() => setStep(AUTH_STEPS.OTP_VERIFICATION)}
                handleNewPassword={handleNewPassword}
                handleNewCheckPassword={handleNewCheckPassword}
              />
            )
          ) : (
            step === 'forgot' && (
              <PhonePasswordSignUp
                password={password}
                setPassword={setPassword}
                checkPassword={checkPassword}
                setCheckPassword={setCheckPassword}
                setStep={setStep}
                valider={() => passwordValidation('forgot')}
                backFunction={() => setStep(AUTH_STEPS.PASSWORD_SETUP)}
                handleNewPassword={handleNewPassword}
                handleNewCheckPassword={handleNewCheckPassword}
              />
            )
          )}
        </div>
      </div>
    </>
  );
};
export default NumberScreen;
